module.exports = __webpack_public_path__ + "static/img/ronit.3b62980.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WhoAreWe/ronit.png
// module id = +LL9
// module chunks = 0